import axios from '../utils/axios';

export const authService = {
  async register(data) {
    const response = await axios.post('/auth/register', {
      companyName: data.companyName,
      rif: data.rif,
      contactName: data.contactName,
      email: data.email,
      phoneNumber: data.phoneNumber,
      password: data.password,
      confirmPassword: data.confirmPassword,
      termsAccepted: data.termsAccepted
    });
    return response.data;
  },

  async login(email, password) {
    try {
      const response = await axios.post('/auth/login', { email, password });

      // Allow login if document verification is pending or waiting for approval
      const allowedStatuses = ['PENDING', 'WAITING_FOR_APPROVAL'];
      const userStatus = response.data.user?.status?.toLowerCase();
      const documentStatus = response.data.user?.documentVerificationStatus;

      const canLogin = userStatus === 'active' || 
        (allowedStatuses.includes(documentStatus) && userStatus === 'inactive');

      if (!canLogin) {
        throw new Error('Your account is inactive. Please contact support for assistance.');
      }

      if (response.data.token) {
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
      }

      return response.data;
    } catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
        throw new Error(error.response.data.message);
      } else {
        throw new Error('An error occurred during login. Please try again later.');
      }
    }
  },

  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },

  async requestPasswordChange(email) {
    const response = await axios.post('/auth/request-password-change', { email });
    return response.data;
  },

  async verifyOtp(email, otp) {
    const response = await axios.post('/auth/verify-otp', {
      email,
      otp: otp.join('')
    });
    return response.data;
  },

  async changePassword(email, token, newPassword) {
    const response = await axios.post('/auth/change-password', {
      email,
      token,
      newPassword
    });
    return response.data;
  },

  isAuthenticated() {
    const token = localStorage.getItem('token');
    return !!token;
  },

  getUser() {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },

  async uploadDocuments(formData) {
    const response = await axios.post('/user/upload-documents', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    await this.getMe();
    return response.data;
  },

  async updateProfile(profileData) {
    try {
      await axios.patch('user/profile', profileData);
      return await this.getMe();
    } catch (error) {
      throw error;
    }
  },

  async updatePassword(updatePasswordData) {
    try {
      const response = await axios.patch('user/update-password', updatePasswordData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getMe() {
    try {
      const response = await axios.get('/user/me');
      const user = response.data.user;
      localStorage.setItem('user', JSON.stringify(user));
      return user;
    } catch (error) {
      throw error;
    }
  }

};
